import { render, staticRenderFns } from "./RegistrationPane.vue?vue&type=template&id=1e0278d2&scoped=true"
import script from "./RegistrationPane.vue?vue&type=script&lang=ts"
export * from "./RegistrationPane.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationPane.vue?vue&type=style&index=0&id=1e0278d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0278d2",
  null
  
)

export default component.exports